import React, { useCallback,useRef,useState,useEffect } from 'react'
import { GoogleMap,Marker, useJsApiLoader,InfoWindow, InfoBox, InfoWindowF } from "@react-google-maps/api";
import db, {auth} from "./firebase"
import { collection, getDocs ,onSnapshot,orderBy,query, QuerySnapshot} from 'firebase/firestore'
import { Style } from './MapDesign';
import { Button } from '@mui/material';
import "./Map.css";
import { center } from '../types';


const options = {
  disableDefaultUI: true,
  zoomControl: true,
  gestureHandling: 'greedy',
  clickableIcons:false,
  styles:Style
};

const containerStyle = {
  height: "100vh",
  width: "100%",
};


const Map=()=> {
  let allSpots :any[]
  let Kanagawa =[

    {price:"江の島",pic:"https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Enoshima_view_from_Kugenuma_beach.jpg/1200px-Enoshima_view_from_Kugenuma_beach.jpg",text:"綺麗すぎた！！",location:{lat:35.30306,lng:139.48122}},
    {price:"スラムダンクの踏切",pic:"https://static.amanaimages.com/imgroom/cen3tzG4fTr7Gtw1PoeRer/25991/25991006858.jpg",text:"",location:{lat:35.30644,lng:139.50208}},
    {price:"鎌倉大仏",pic:"https://i0.wp.com/kamakura-guide.jp/wp-content/uploads/2013/04/016_daibutu_2014_tuika_2.jpg?fit=450%2C600&ssl=1",text:"",location:{lat:35.31689,lng:139.53496}},
    {price:"小町通り",pic:"https://cdn.zekkei-japan.jp/images/spots/68a0c7419252fd8dcb315058e4c61570.jpg",text:"",location:{lat:35.32262,lng:139.55243}},
    {price:"建長寺",pic:"https://www.shonan-navi.net/images/A00004412.png?1545153428",text:"",location:{lat:35.33173,lng:139.55546}},
    {price:"明月院",pic:"https://www.trip-kamakura.com/uploaded/image/5660.jpg",text:"",location:{lat:35.33551,lng:139.55079}},
    {price:"円覚寺",pic:"https://kamakuratrip.com/img/engakuji_sanmon_220612.jpeg",text:"",location:{lat:35.33788,lng:139.54635}},
    {price:"鶴岡八幡宮",pic:"https://s3-ap-northeast-1.amazonaws.com/thegate/2020/12/25/15/52/13/Tsuruoka-Hachimangu.jpg",text:"",location:{lat:35.32501,lng:139.55542}},
    {price:"辻堂海浜公園",pic:"https://www.fujisawa-kanko.jp/global-image/units/img/17008-10-20190225171651_b5c73a4731d2f5.jpg",text:"",location:{lat:35.32096,lng:139.44824}},
    {price:"茅ヶ崎サザンビーチ",pic:"https://chigasaki.heart21.jp/wp-content/uploads/2021/08/2-8.jpg",text:"",location:{lat:35.31795,lng:139.39671}},
    {price:"大磯ロングビーチ",pic:"https://upload.wikimedia.org/wikipedia/commons/3/32/OISO.jpg",text:"",location:{lat:35.30197,lng:139.28281}},
    {price:"ヌードルワークス",pic:"https://class-shonan.com/wp-content/uploads/2019/02/img_2498-1024x768-1024x768.jpg",text:"",location:{lat:35.33800,lng:139.48856}},
    {price:"家系総本山吉村屋",pic:"https://tblg.k-img.com/restaurant/images/Rvw/77655/640x640_rect_77655203.jpg",text:"",location:{lat:35.46372,lng:139.61624}},
  ]

  const [geo,setGeo] = useState<any[]>([])
  
  
  useEffect(() => {
    const postData=collection(db,"posts")
    const q =query(postData ,orderBy("timestamp","desc")) 
    onSnapshot(q,(querySnapshot)=>{
      setGeo(querySnapshot.docs.map((doc)=>({...doc.data(),id:doc.id})))
    })
  }, [])
  
  allSpots = Kanagawa.concat(geo)

  
  const {isLoaded}= useJsApiLoader({
    id:'google-map-script',
    googleMapsApiKey:"AIzaSyAGQ3UnxYDs-DziKsRr1fLqatZCM0o9Fm0",
  })

  const mapRef = useRef()
  const searchRef = useRef(null)

  const onLoad = useCallback((map:any)=>(mapRef.current),[])

  
  
  const [lat,setLat] = useState<number|null>(null)
  const [lng,setLng] = useState<number|null>(null)
  const [newcenter,setNewcenter]=useState<center>({lat:35.39681, lng: 139.46169,})
  const [selected,setSelected] = useState<any>(null)
  const [review,setReview] = useState<boolean>(false)

  
  const clickMap = () =>{
    if(!searchRef.current.value) {
      return;
    }
    else{
     geocode()
     setNewcenter({lat:lat,lng:lng})
  } 
}

  const geocode= ()=>{
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({address:searchRef.current.value},(results,status)=>{
      if (status === 'OK'){
        const NEW_LAT:number = results[0].geometry.location.lat()
        const NEW_LNG:number = results[0].geometry.location.lng()
        setLat((prevState)=>prevState=NEW_LAT)
        setLng((prevState)=>prevState=NEW_LNG)
      }
      else{
        window.alert("存在しません")
      }
    })
    
  }
  
     
    

  

  

  return (
    <>
    <div className='GoogleMap'>
     <div className='Google-search'>
       <div className='Google-input'>
         <input placeholder='気になるエリアを調べてみよう' 
                type="text" 
                ref ={searchRef}
         />
         <Button onClick={clickMap}>検索</Button>
       </div>
     </div>
      {isLoaded&&
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={newcenter}
        zoom={11}
        options={options}
        onLoad={onLoad}
      >
       {allSpots.map((item)=>(
        <div className='GoogleMapInfo' key={item.location.lat*item.location.lng}>
         <Marker
          onClick={
            ()=>{
              setSelected(item)
              setReview(true)
              
            }
          }
          position={{lat:item.location.lat,lng:item.location.lng}}
          animation={2}
          icon={"https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"}
          />
         
        </div>
       ))}

       {
        selected ?(
          <InfoWindow
          position={{
            lat:selected.location.lat,
            lng:selected.location.lng,
          }}
          onCloseClick={
            ()=>{
              setSelected(null)
              setReview(false)
            }
          }
          options={{maxWidth:400}}
          >
            <div className='detail-Info'>
             <div className='detail-picture'>
              <img src={selected.pic} width="360px" height="300px" />
              </div>
             <div className='detail-text'>
              <h4>{selected.price}</h4>
             </div>
             <div className='detail-user'>  
                  <p>
                  {selected.text}
                  </p>
             </div>
              
             </div>

          </InfoWindow>
        ): null}
        

        
      </GoogleMap>
      }
    </div>
     
      
    </>
  )
}

export default Map